// Division arrives from getDivisionAndFacultiesForSubject as a string, an array,
// or null. Vue renders an array straight to JSON in a template, so normalise it
// to a plain readable string before it reaches the markup.
export function formatDivision(division) {
  if (Array.isArray(division)) return division.filter(Boolean).join(", ");
  return division ? String(division).trim() : "";
}

// "Dr. Rajesh Sharma" -> "RS"
export function initialsOf(name) {
  return (
    (name || "")
      .replace(/^(Dr|Prof|Mr|Mrs|Ms)\.?\s+/i, "")
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0].toUpperCase())
      .join("") || "-"
  );
}

// "Dr. Rajesh Sharma (Division A)" — division appended only when present.
export function facultyWithDivision(faculty) {
  const division = formatDivision(faculty.division);
  return division ? `${faculty.name} (${division})` : faculty.name;
}

// Comma-separated faculty names, each with its division.
export function facultyNames(facultyDetails) {
  return (facultyDetails || [])
    .filter((f) => f && f.name)
    .map(facultyWithDivision)
    .join(", ");
}
